import { createFileRoute } from "@tanstack/react-router";
import Overview from "@/components/Overview/index";
import Page from "@/components/Page";

function OverviewPage() {
  return (
    <Page contentPadding maxWidth="xl">
      <Overview />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/")({
  component: OverviewPage,
});
